












import { Component, Mixins } from "vue-property-decorator";
import { TextDrawableObjectDrawerBase } from "./base";
import { default as NamedRectangleCoordinatableObjectDrawer } from "./NamedRectangleCoordinatableObjectDrawer.vue";

@Component({
  components: {
    NamedRectangleCoordinatableObjectDrawer,
  },
})
export default class ScriptLinkObjectDrawer extends Mixins(TextDrawableObjectDrawerBase) {}
